import moment from 'moment'
import axios from 'axios'
import request from '../api/request'

export const QINIU_BUCKET = 'china-sport'
export const QINIU_CDN_DOMAIN = 'https://sport-cdn.qietongvip.com'
// china-sport 在华南区，需使用 z2 上传域名
const DEFAULT_UPLOAD_URL = 'https://up-z2.qiniup.com'

/** 生成七牛对象 key（与原先 OSS 路径规则一致） */
export function buildUploadKey (path, file, datedir = false) {
  const name = (file && file.name) || file
  const parts = String(name).split('.')
  const ext = parts.length > 1 ? parts.pop() : 'bin'
  const baseName = parts.join('.') || 'file'
  const uid = (file && file.uid) || new Date().valueOf()
  const prefix = path.endsWith('/') ? path : `${path}/`
  if (datedir) {
    return `${prefix}${moment().format('YYYYMMDD')}-${baseName}-${uid}.${ext}`
  }
  return `${prefix}${moment().format('YYYYMMDD')}/${baseName}-${uid}.${ext}`
}

function getAuthHeaders () {
  const userinfo = localStorage.getItem('access_info')
  return {
    'X-Request-Token': userinfo ? JSON.parse(userinfo).token : '',
  }
}

/**
 * 获取七牛上传凭证
 * 接口 /config/qiniuToken 响应体即为 token 纯文本，无 JSON 结构
 */
export function fetchQiniuToken (extraParams = {}) {
  const params = { bucket: QINIU_BUCKET, bucketName: QINIU_BUCKET, ...extraParams }
  return axios({
    baseURL: request.baseURL,
    url: '/config/qiniuToken',
    method: 'GET',
    params,
    responseType: 'text',
    transformResponse: [(data) => data],
    headers: getAuthHeaders(),
    timeout: 30000,
  }).then(res => {
    const token = String(res.data || '').trim()
    if (!token) {
      return Promise.reject(new Error('七牛 token 为空'))
    }
    return {
      token,
      domain: QINIU_CDN_DOMAIN,
      uploadUrl: DEFAULT_UPLOAD_URL,
      presetKey: null,
    }
  })
}

/**
 * 上传文件到七牛
 * @param {File|Blob} file
 * @param {string} key 对象 key
 * @returns {Promise<string>} 文件访问 URL
 */
export function uploadFileToQiniu (file, key) {
  return fetchQiniuToken().then(({ token, domain, uploadUrl, presetKey }) => {
    const uploadKey = key || presetKey
    if (!uploadKey) {
      return Promise.reject(new Error('上传 key 不能为空'))
    }
    const formData = new FormData()
    formData.append('token', token)
    formData.append('key', uploadKey)
    formData.append('file', file)

    return fetch(uploadUrl, { method: 'POST', body: formData })
      .then(response => response.json())
      .then(result => {
        if (result.error) {
          return Promise.reject(new Error(result.error))
        }
        const finalKey = result.key || uploadKey
        const base = (domain || QINIU_CDN_DOMAIN).replace(/\/$/, '')
        return `${base}/${finalKey}`
      })
  })
}
